"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BannerImage = void 0;
const react_1 = __importStar(require("react"));
const shell_banner_full_webp_1 = __importDefault(require("../images/shell-banner-full.webp"));
const shell_banner_half_night_webp_1 = __importDefault(require("../images/shell-banner-half-night.webp"));
const shell_banner_full_night_webp_1 = __importDefault(require("../images/shell-banner-full-night.webp"));
const shell_banner_half_webp_1 = __importDefault(require("../images/shell-banner-half.webp"));
const react_next_1 = require("@geome/react-next");
const BannerImage = ({ className, siteStatus }) => {
    const divClassName = (0, react_next_1.useBEM)({
        block: "location-page",
        element: "header-banner-image",
        modifiers: {
            "is-closed": siteStatus !== undefined && siteStatus !== "Active",
        },
    });
    const darkMode = (0, react_next_1.useMatchMedia)("(prefers-color-scheme: dark)");
    const [halfImage, fullImage] = (0, react_1.useMemo)(() => {
        return darkMode
            ? [shell_banner_half_night_webp_1.default, shell_banner_full_night_webp_1.default]
            : [shell_banner_half_webp_1.default, shell_banner_full_webp_1.default];
    }, [darkMode]);
    return (react_1.default.createElement("div", { className: divClassName },
        react_1.default.createElement("picture", null,
            react_1.default.createElement("source", { media: "(max-width: 700px)", src: halfImage }),
            react_1.default.createElement("source", { src: fullImage }),
            react_1.default.createElement("img", { className: className, "aria-hidden": "true", role: "presentation", src: fullImage, alt: "" }))));
};
exports.BannerImage = BannerImage;
